import React, { useState } from "react";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import {
  useCreateRequestComment,
  useRequestComments,
} from "@/components/pages/requests/hooks/requestComments.hooks";
import CommentItem from "./CommentItem";

type Props = { requestId: string };

export const CommentsSection: React.FC<Props> = ({ requestId }) => {
  const [content, setContent] = useState("");
  const { data } = useRequestComments({ requestId });
  const createMutation = useCreateRequestComment();

  const submit = async () => {
    if (!content.trim()) return;
    await createMutation.mutateAsync({ requestId, content: content.trim() });
    setContent("");
  };

  return (
    <div className="space-y-3">
      <CardHeader className="p-0">
        <CardTitle>Comments</CardTitle>
      </CardHeader>
      <CardContent className="p-0 space-y-2">
        <div className="flex flex-col gap-2">
          <Textarea
            placeholder="Write a comment..."
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
          <Button
            size="sm"
            onClick={submit}
            className={"max-w-fit"}
            disabled={createMutation.isPending || !content.trim()}
          >
            Add comment
          </Button>
        </div>
        {!!data?.length && (
          <div className="flex flex-col gap-y-1">
            {data?.map((c) => (
              <CommentItem key={c.id} comment={c} />
            ))}
          </div>
        )}
      </CardContent>
    </div>
  );
};

export default CommentsSection;
